import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}

export function formatDateShort(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function slugify(text) {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .trim();
}

export function truncate(text, length = 150) {
  if (!text || text.length <= length) return text;
  return text.substring(0, length).trim() + '...';
}

export function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '');
}

export function calculateReadingTime(content) {
  if (!content) return 1;
  const text = stripHtml(content);
  const words = text.split(/\s+/).length;
  return Math.max(1, Math.round(words / 200));
}

export const WHATSAPP_URL = 'https://wa.me/5595991548020?text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20os%20servi%C3%A7os%20da%20Apex%20Medical%20Hub';
export const LP_URL = WHATSAPP_URL;

export const SERVICES = [
  {
    id: 'contabilidade',
    title: 'Contabilidade Tributária',
    description: 'Planejamento fiscal especializado para profissionais e empresas médicas, garantindo conformidade e economia.',
    icon: 'Calculator',
  },
  {
    id: 'bpo-financeiro',
    title: 'BPO Financeiro',
    description: 'Terceirização completa das rotinas financeiras: contas a pagar, receber, conciliação e fluxo de caixa.',
    icon: 'Wallet',
  },
  {
    id: 'bpo-rh',
    title: 'BPO de RH',
    description: 'Gestão de folha, admissões, demissões e compliance trabalhista para equipes médicas.',
    icon: 'Users',
  },
  {
    id: 'faturamento',
    title: 'Faturamento',
    description: 'Otimização do faturamento de convênios, redução de glosas e maximização de receitas.',
    icon: 'Receipt',
  },
  {
    id: 'rateio',
    title: 'Rateio entre Profissionais',
    description: 'Divisão precisa e transparente de receitas entre múltiplos profissionais da mesma estrutura.',
    icon: 'PieChart',
  },
  {
    id: 'marketing',
    title: 'Marketing Médico',
    description: 'Estratégias de posicionamento e captação de pacientes dentro das normas do CFM.',
    icon: 'Megaphone',
  },
  {
    id: 'gestao',
    title: 'Gestão Completa',
    description: 'Operação integrada de todos os processos administrativos e financeiros da clínica.',
    icon: 'Settings',
  },
  {
    id: 'analytics',
    title: 'Business Analytics',
    description: 'Dashboards e indicadores de performance para tomada de decisão baseada em dados.',
    icon: 'BarChart3',
  },
  {
    id: 'planejamento',
    title: 'Planejamento Estratégico',
    description: 'Construção de planos de crescimento e metas para sua clínica ou consultório.',
    icon: 'Target',
  },
];

export const PAIN_POINTS = [
  'Você sente que seu lucro está sendo drenado e não consegue identificar onde.',
  'Paga impostos com a sensação de estar pagando errado.',
  'Vive com medo de multas porque nunca revisou seu modelo tributário.',
  'Sua rotina é caótica e você não tem previsibilidade financeira.',
  'Não sobra tempo para focar nos pacientes por causa da burocracia.',
];

export const BENEFITS = [
  {
    title: 'Previsibilidade Total',
    description: 'Saiba exatamente quanto entra, quanto sai e quanto sobra todo mês.',
  },
  {
    title: 'Redução Fiscal Imediata',
    description: 'Pague o mínimo legal através de planejamento tributário especializado.',
  },
  {
    title: 'Backoffice de Confiança',
    description: 'Um time consultivo cuidando da burocracia enquanto você cuida dos pacientes.',
  },
  {
    title: 'Decisões Baseadas em Dados',
    description: 'Indicadores claros para tomar decisões estratégicas com segurança.',
  },
];
